import { cn } from '@/renderer/lib/utils';
import React from 'react';

interface BillingSurfaceProps {
  children: React.ReactNode;
  className?: string;
  compact?: boolean;
  tone?: 'default' | 'tinted' | 'inverse';
}

const toneClasses: Record<NonNullable<BillingSurfaceProps['tone']>, string> = {
  default:
    'border-slate-200/80 bg-white shadow-[0_14px_32px_rgba(15,23,42,0.05)]',
  tinted:
    'border-emerald-100 bg-[linear-gradient(180deg,rgba(240,253,244,0.92),rgba(255,255,255,1))] shadow-[0_14px_32px_rgba(22,101,52,0.08)]',
  inverse:
    'border-slate-900/80 bg-[linear-gradient(180deg,#0f172a,#111827)] text-white shadow-[0_22px_44px_rgba(15,23,42,0.24)]',
};

export const BillingSurface: React.FC<BillingSurfaceProps> = ({
  children,
  className,
  compact = false,
  tone = 'default',
}) => {
  return (
    <section
      className={cn(
        'rounded-[26px] border backdrop-blur-sm',
        compact ? 'p-4' : 'p-5 sm:p-6',
        toneClasses[tone],
        className,
      )}
    >
      {children}
    </section>
  );
};
